// extracted by mini-css-extract-plugin
export default {"shimmer":"MarketplaceCardSlider_shimmer__WZa8j","dark_shimmer":"MarketplaceCardSlider_dark_shimmer__b3ZNw","slider":"MarketplaceCardSlider_slider__C0l8b"};